import { useQuery } from "@tanstack/react-query";
import { useThoughtSpotAPI } from "@/api";

export const EmailSchedulesQueryKey = "emailSchedules" as const;

export function useGetEmailSchedules() {
  const api = useThoughtSpotAPI();

  return useQuery({
    queryKey: [EmailSchedulesQueryKey],
    queryFn: async () => {
      const r = await api.getThoughtspotSchedules();
      return r.data;
    },
  });
}
